import { LoadingController } from '@ionic/angular';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AlertController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { Observable, Subject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Item, ItemRental, ItemType, RentalStatus } from './rental.model';

const url = environment.api;

@Injectable({
  providedIn: 'root'
})
export class RentalService {

  tableName = "rental_item";
  items: Item[] = [];

  filteredElementsLength: number;
  private currentStatus: string = '';
  statusChangeSubject: Subject<null> = new Subject<null>()
  // items: Item[] = [
  //   { id: 1, name: "ksiazka 1", description: "description", type: ItemType.Book },
  //   { id: 2, name: "ksiazka 2", description: "description2", type: ItemType.Book },
  // ];

  // itemRentals: ItemRental[] = [
  //   { id: 1, idUser: 1, dateCreated: new Date('2021-11-04'), dateFrom: new Date('2021-11-04'), dateTo: new Date('2021-11-05'), idItem: 1, status: RentalStatus.Return },
  //   { id: 2, idUser: 1, dateCreated: new Date('2021-11-04'), dateFrom: new Date('2021-11-04'), dateTo: new Date('2021-11-05'), idItem: 1, status: RentalStatus.Return },
  //   { id: 3, idUser: 1, dateCreated: new Date('2021-11-05'), idItem: 1, status: RentalStatus.Reservation }
  // ];


  constructor(
    private http: HttpClient,
    private translate: TranslateService,
    private alertCtrl: AlertController,
    private loadingCtrl: LoadingController,
  ) { }

  getItems(type: ItemType) {
    return this.http.get<Item[]>(url + 'item?type=' + type);
  }

  getItem(itemId: number) {
    return this.http.get<Item>(url + 'item/' + itemId);
  }

  deleteItem(itemId: number) {
    return this.http.delete(url + 'item/' + itemId);
  }

  postItem(item: any) {
    return this.http.post(url + 'item', item);
  }

  putItem(itemId: number, item: any) {
    return this.http.put(url + 'item/' + itemId, item);
  }

  getItemRentals(itemId: number) {
    return this.http.get<ItemRental[]>(url + 'item-rental?idItem=' + itemId);
  }

  postItemRental(itemRental: ItemRental) {
    return this.http.post(url + 'item-rental', itemRental);
  }

  putItemRental(itemRetnalId: number, itemRental: ItemRental) {
    return this.http.put(url + 'item-rental/' + itemRetnalId, itemRental)
  }

  deleteItemRental(itemRetnalId: number) {
    return this.http.delete(url + 'item-rental/' + itemRetnalId);
  }

  async itemRentalReservation(itemId: number) {
    let itemRental = new ItemRental();
    itemRental.idItem = itemId;
    itemRental.status = RentalStatus.Reservation;
    await this.postItemRental(itemRental).toPromise()
    .then(async () => {
     this.showAlertAfterRequestHTTP('RENTAL.RESERVED');
    })
    .catch(
      async () => {
        this.showAlertAfterRequestHTTP(null, true)
      });
  }

  notyfiItemRental(itemRetnalId: number) {
    return this.http.post(url + 'item-rental/notify/' + itemRetnalId, null)
  }


  handleStausChange(): Observable<null> {
    return this.statusChangeSubject.asObservable();
  }

  getCurrentStatus() {
    return this.currentStatus;
  }
  setCurrentStatus(status: string) {
    this.currentStatus = (status === 'ALL' || status.length === 0) ? '' : status;
    this.statusChangeSubject.next(null);
  }
  getStatusColor(statusName: string): string {
    switch(statusName) {
      case 'RESERVATION':
        return '#fcca4e';
      case 'RENT':
        return '#ff6a00';
      case 'RETURN':
        return '#39a0fa';
      default:
        return '#5eb75f';
    }
  }

  async showAlertAfterRequestHTTP(message, isError: boolean = false){
    if(isError) {
      const alert = await this.alertCtrl.create({
        header: this.translate.instant("RENTAL.ERROR"),
        buttons: [
          {
            text: "Ok",
            handler: () => {
            },
          }
        ]
      });
      alert.present()
    } else {
      const alert = await this.alertCtrl.create({
        header: this.translate.instant("CONFIRM"),
        message: this.translate.instant(message),
        buttons: [
          {
            text: "Ok",
            handler: () => {
            },
          }
        ]
      });
      alert.present()
    }
  }
}